import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled from 'styled-components';
import PinIcon from './PinIcon';
import parsePtBrFloat from '../../helpers/parsePtBrFloat';
import computePinPositionStyleDynamically from './computePinDinamically';
import { Flex } from '../Flex';
export const FullWidthFlex = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  max-width: 326px;\n"])));
export const RulerFlex = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  gap: var(--spacing-0-25);\n"])));
export const Rect = styled.div.attrs(props => ({
  fillColor: props.fillColor,
  radius: props.radius || '0px 0px 0px 0px',
  width: props.width
}))(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  width: min(", ", 100%);\n  height: 20px;\n  background: ", ";\n  border-radius: ", ";\n"])), props => props.width, props => props.fillColor, props => props.radius);
export const TooltipContainer = styled(Flex)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: var(--color-neutral-80);\n  text-align: center;\n  border-radius: var(--spacing-0-5);\n  margin-bottom: var(--spacing-1);\n  padding: var(--spacing-0-5);\n  position: relative;\n  filter: drop-shadow(var(--shadow-level-1));\n"])));
const fixedPinVerticalPositionStyle = "\n  position: absolute;\n  bottom: calc((-1 * var(--spacing-1)) + 1px);\n";
export const PricePin = styled(PinIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), _ref => {
  let {
    pinposition,
    quartile,
    adPrice,
    olxPrice
  } = _ref;
  let pinPositionStyle = '';
  const onlyPrice = parsePtBrFloat(adPrice);
  if (pinposition === 'left') {
    pinPositionStyle = "".concat(fixedPinVerticalPositionStyle, " left: 5%;");
  }
  if (pinposition === 'right') {
    pinPositionStyle = "".concat(fixedPinVerticalPositionStyle, " right: 5%;");
  }
  if (pinposition === 'dynamic') {
    pinPositionStyle = computePinPositionStyleDynamically(quartile, onlyPrice, olxPrice);
  } else {
    pinPositionStyle = "\n        ".concat(fixedPinVerticalPositionStyle, "\n        left: calc(50% - var(--spacing-1));\n      ");
  }
  return pinPositionStyle;
});